export interface Version {
  lib: string;
}

export const version: Version = {
  lib: '1.1.0'
};
